import React, {useEffect} from 'react';
import CompaniesHero from '../../../features/Components/Companies/CompaniesHero';
import Employees from '../../../features/Components/Companies/Employees';
import dayjs from 'dayjs';
import {useDispatch, useSelector} from 'react-redux';
import {getProjectReviewEmployee} from '../../../redux/actions/projects/projectsActions';
import {dateFormat} from '../../../helpers/constants';
import LoadPanel from '../../Components/LoadPanel';
import NoItems from '../../Components/NoItems';

import './ProjectsAssessments.scss';
import {useTranslation} from 'react-i18next';

const ProjectsAssessments = () => {
    const {t} = useTranslation();

    const {
        projectEmployeesReview,
        projectEmployeesReviewLoading,
        singleProject
    } = useSelector((state) => state.projects);
    const dispatch = useDispatch();

    useEffect(() => {
        if (projectEmployeesReviewLoading && !projectEmployeesReview.length) {
            dispatch(getProjectReviewEmployee(singleProject.id));
        }
    }, [dispatch, singleProject.id, projectEmployeesReviewLoading]);


    const groupedReviews = projectEmployeesReview?.flatMap(({date, reviews}) => {
        const clientsMap = new Map();

        reviews.forEach((review) => {
            if (!clientsMap.has(review.clientId)) {
                clientsMap.set(review.clientId, {
                    date,
                    clientName: review.clientName,
                    clientRole: review.clientRole,
                    reviews: []
                });
            }
            clientsMap.get(review.clientId).reviews.push(review);
        });

        return Array.from(clientsMap.values());
    });


    if (projectEmployeesReviewLoading) {
        return (
            <div className={'companies-page-loader'}>
                <LoadPanel noBg={true} circleSize={50} staticPos={true}/>
            </div>
        );
    }

    return (
        <div className='projects-assessments-wrapper'>
            <div className='projects-assessments'>
                <div className='projects-name'>{singleProject.address}</div>

                <CompaniesHero subHeading={t('ProjectsAssessments.employeeRatings')}/>

                <div className='projects-assessments__content'>
                    <div className='projects-assessments__list-wrapper'>
                        {groupedReviews.length > 0 ? (
                            <div className='projects-assessments__list'>
                                {groupedReviews.map(({date, clientName, clientRole, reviews}, idx) => (
                                    <div className='items' key={idx}>
                                        <div className='items-date'>{dayjs(date).format(dateFormat)}</div>
                                        <div className={'items-client'}>{clientName} ({clientRole})</div>

                                        {reviews.map(({firstName, roleName, status, mark, avatar, id}) => (
                                            <Employees
                                                key={id}
                                                name={firstName}
                                                position={roleName}
                                                status={status}
                                                id={id}
                                                avatar={avatar}
                                                mark={mark}
                                                fire={false}
                                                review={true}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <NoItems title={t('ProjectsAssessments.employeeRatingsNoItems')} center={'center'}/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectsAssessments;
